export default {
  namespaced: true,
  state: {
    selectedAddress: null,
    selectedPaymentMethod: null,
    step: 1,
    loading: false,
    error: null
  },
  getters: {
    selectedAddress: (state) => state.selectedAddress,
    selectedPaymentMethod: (state) => state.selectedPaymentMethod,
    currentStep: (state) => state.step,
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    isCheckoutComplete: (state) => state.step > 3
  },
  mutations: {
    SET_ADDRESS(state, address) {
      state.selectedAddress = address;
    },
    SET_PAYMENT_METHOD(state, method) {
      state.selectedPaymentMethod = method;
    },
    SET_STEP(state, step) {
      state.step = step;
    },
    NEXT_STEP(state) {
      state.step++;
    },
    PREV_STEP(state) {
      state.step--;
    },
    RESET_CHECKOUT(state) {
      state.selectedAddress = null;
      state.selectedPaymentMethod = null;
      state.step = 1;
      state.error = null;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    setAddress({ commit }, address) {
      commit('SET_ADDRESS', address);
    },
    setPaymentMethod({ commit }, method) {
      commit('SET_PAYMENT_METHOD', method);
    },
    nextStep({ commit }) {
      commit('NEXT_STEP');
    },
    prevStep({ commit }) {
      commit('PREV_STEP');
    },
    resetCheckout({ commit }) {
      commit('RESET_CHECKOUT');
    }
  }
};